import { render, staticRenderFns } from "./editPd.vue?vue&type=template&id=6d3b5a7e&"
import script from "./editPd.vue?vue&type=script&lang=js&"
export * from "./editPd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports